// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a6d1b418","453":"5445c515","455":"c8f65e51","977":"abe63e81"}[chunkId] + ".chunk.js";
};